
import { getFullProductPrice } from '~~/helpers/product/getPriceInfo';
import type { UseProductExtendedReturn } from '~/composables/useProductExtended';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

const cartLineItemSlugsCookie = 'cart-line-item-slugs';

export const useCheckoutTagManager = () => {

  const { cart } = useCartExtended();
  const { $cookies } = useNuxtApp();

  const cartLineItemSlugs = (
    cart.value?.lineItems?.map(item => item.productSlug) ||
    $cookies.get(cartLineItemSlugsCookie) ||
    []
  )?.filter((slug): slug is string => !!slug);

  $cookies.set(cartLineItemSlugsCookie, cartLineItemSlugs);
  const extendedProductsList: UseProductExtendedReturn[] =
    cartLineItemSlugs?.map(productSlug => useProductExtended(productSlug));
  const searchProducts = extendedProductsList?.map(item => item.search);

  const products: ComputedRef<ProductVariantExtended[]> = computed(() => {

    return extendedProductsList?.map(extendedProduct => {

      const { masterProduct } = extendedProduct;
      const originalPrice = masterProduct.value
        ? getFullProductPrice(masterProduct.value)
        : null;

      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      return {
        ...masterProduct.value,
        originalPrice,
      } as ProductVariantExtended;
    
    });
  
  });

  const loadProducts = async () => {

    const searchPromises = cartLineItemSlugs?.map((productSlug, i) => {

      const searchParams = {
        slug: productSlug,
      };

      return searchProducts[i](searchParams);
    
    });
    await Promise.allSettled(searchPromises);
  
  };

  return {
    products,
    loadProducts,
  };

};
